<div *ngIf="!hideDialog" class="assessment-dialog-content-wrapper">
    <div>
    <mat-toolbar matDialogTitle class="mat-accent m-0 mb-24">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" style="overflow:hidden">
            <span class="title dialog-title text-truncate">{{title}}</span>
            <button mat-icon-button class="mat-icon-button white-fg"
                    (click)="dialogRef.close()"
                    aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0 pt-0">
        <form [formGroup]="form" #formControl="ngForm" class="assessment-form" fxLayout="column" fxFlex>

            <mat-form-field class="p-8 m-0 form-control" style='max-width: 400px;'>
              <mat-label>Template</mat-label>
                <mat-select  id="assessmentTemplate" class="form-control" formControlName="assessmentTemplateId" name="assessmentTemplate" (selectionChange)="assessmentTemplateChanged($event)" [setFocus]="true">
                    <mat-option *ngFor="let item of assessmentTemplates" [value]="item.id">
                    {{item.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div *ngIf="assessmentTemplate" class="p-8 m-0" fusePerfectScrollbar>
                <div *ngFor="let category of assessmentCategories" class="py-8">
                    <div><span>{{category.name}}</span></div>
                    <div class="pt-8 pb-16">
                        <app-check-list [multiselect]="true" [readOnly]="readOnly" [list]="category.types" (onChanged)="typeChanged($event, category)"></app-check-list>
                    </div>
                    <div><span>Score: {{category.score}}</span></div>
                    <mat-divider class="mt-16"></mat-divider>
                </div>
            </div>

            <div *ngIf="assessmentTemplate" class="pt-24 px-8 m-0">
                <div class="py-8" fxLayout="row">
                    <div class="total-score">Total Score: {{totalScore}}</div>
                    <div *ngIf="assessmentTemplate.acceptanceThreshold" class="mat-accent"> / {{assessmentTemplate.acceptanceThreshold}}</div>
                </div>
            </div>
        </form>
    </div>
    </div>
    <div *ngIf="assessmentTemplate" mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div *ngIf="!readOnly" fxLayout="row">
            <div class="pr-4">
                <button id="btnSaveProgress" mat-raised-button
                        type="submit"
                        (click)="saveProgress()"
                        class="mat-accent"
                        aria-label="SAVE PROGRESS">
                    SAVE PROGRESS
                </button>
            </div>
            <div *ngIf="!assessmentTemplate?.autoReview">
                <button id="btnSubmit" mat-raised-button
                        type="submit"
                        (click)="submit()"
                        class="mat-accent"
                        aria-label="SAVE">
                    SAVE
                </button>
            </div>
            <div *ngIf="assessmentTemplate?.autoReview && (!override) && (!rejected) ">
                <button id="btnSubmit" mat-raised-button
                        type="submit"
                        (click)="accept()"
                        class="bg-green"
                        aria-label="ACCEPT">
                    ACCEPT
                </button>
            </div>
            <div *ngIf="assessmentTemplate?.autoReview && override && rejected">
                <button id="btnSubmit" mat-raised-button
                        type="submit"
                        (click)="accept(true)"
                        class="bg-green"
                        aria-label="ACCEPT OVERRIDE">
                    ACCEPT (OVERRIDE)
                </button>
            </div>
            <div *ngIf="assessmentTemplate?.autoReview && (!override) && rejected">
                <button id="btnSubmit" mat-raised-button
                        type="submit"
                        (click)="reject()"
                        class="mat-warn"
                        aria-label="REJECT">
                    REJECT
                </button>
            </div>
            <div *ngIf="assessmentTemplate?.autoReview && override && (!rejected)">
                <button id="btnSubmit" mat-raised-button
                        type="submit"
                        (click)="reject(true)"
                        class="mat-warn"
                        aria-label="REJECT OVERRIDE">
                    REJECT (OVERRIDE)
                </button>
            </div>
        </div>
        <div *ngIf="readOnly && assessment && assessment.review">
            <div>
                <button id="btnViewReview" mat-raised-button
                        type="submit"
                        (click)="viewReview()"
                        class="mat-accent"
                        aria-label="VIEW REVIEW">
                    VIEW REVIEW
                </button>
            </div>
        </div>
        <div *ngIf="(assessmentTemplate?.autoReview && isAdmin && (!readOnly)) || (readOnly && assessment.review)" class="pt-8">
            <mat-checkbox [checked]="this.override" name="override" id="override" (change)="overrideChange($event)" [disabled]="readOnly">Override</mat-checkbox>
        </div>
    </div>
</div>
